import React, { useEffect, useState } from "react";
import { Navbar, Nav, NavDropdown,Container } from 'react-bootstrap';
import { Link,NavLink  } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import CandidateHeader from '../Candidate Navbar/Header';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {   faUser } from '@fortawesome/free-solid-svg-icons'
import {   faRightFromBracket } from '@fortawesome/free-solid-svg-icons'
import placmentLogo from '../../../assets/placementlogow.png'

import './CandidateNavbar.css'

export default function CandidateNavbar() {
    const navigate = useNavigate();
    const [name,setName] = useState('');
    const [registerNumber,setRegisterNumber] = useState('');
   


  useEffect( () => {
    const user = localStorage.getItem("user");
    if(user === null){
      localStorage.removeItem("user");
      navigate('/Candidate_Login' ); 
    }
    else{
      setName(JSON.parse(user)[0].name__first_name);
      setRegisterNumber(JSON.parse(user)[0].register_num);
    }
  },[])

  const handleClick = () => {
    localStorage.removeItem("user");
    navigate('/Candidate_Login' );
  }

  return (
    < >
      <CandidateHeader/>
      <Navbar   sticky="top"  variant="dark" expand="sm" style={{ backgroundColor: '#309197',boxShadow: "0 2px 6px rgba(0,0,0,0.05)"}}>
   
        <Container>
           <Navbar.Brand >
            <NavLink to="/Candidate_Dashboard">
              <img src={placmentLogo} alt="logo" width="160px" height="45px" />
  
         
            </NavLink>
           </Navbar.Brand>
           <Navbar.Toggle/>

           <Navbar.Collapse >
             <Nav className="ms-3 me-auto" id="nav" >
             <NavLink    to="/Candidate_Dashboard" className="nav-link me-2" >Home</NavLink>
            <NavLink to="/Candidate_Status"  className="nav-link" >Job Status</NavLink>
            </Nav>
            <Nav  className="ms-3" >
               <Navbar.Text  className="d-none d-md-block" style={{color:"#c5f7e4"}}> [ {registerNumber} ]  </Navbar.Text>
               <NavDropdown title= {name}   >
                  <NavDropdown.Item  className="p-2" id="nav-drop" style={{textDecoration:'none',color:'#000'}} 
                    onClick={()=> navigate('/Candidate_Profile' ) }  >
                      <FontAwesomeIcon icon={faUser} /> <span >Profile</span>

                  {/* <Link to="/Candidate_Profile" style={{textDecoration:'none',color:'#000'}} >
                  <FontAwesomeIcon icon={faUser} /> <span >Profile</span></Link> */}
                  </NavDropdown.Item>

                  <NavDropdown.Item  className="p-2" onClick={handleClick} id="nav-drop"  style={{textDecoration: "none",color:'#000'}}>
                  <FontAwesomeIcon icon={faRightFromBracket} />  <span>Logout</span>
                      {/* <Link to="/Candidate_Login" onClick={handleClick} style={{textDecoration: "none",color:'#000'}}>
                      <FontAwesomeIcon icon={faRightFromBracket} />  <span>Logout</span></Link> */}
                  </NavDropdown.Item>
               </NavDropdown>
            </Nav>
           </Navbar.Collapse>
           </Container>
       </Navbar>
      
    </>
  )
}